import { ReactNode } from 'react';
import posthog from 'posthog-js';
import { PostHogErrorBoundary, PostHogProvider } from '@posthog/react';
import { posthogInit } from '@shared/posthog';

export function PostHogWrapper({ children }: { children: ReactNode }) {
  const projectToken = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN as string | undefined;
  const apiHost = import.meta.env.VITE_POSTHOG_HOST as string | undefined;

  if (!projectToken || !apiHost) {
    return <>{children}</>;
  }

  const initialized = posthogInit({
    projectToken: projectToken!,
    apiHost: apiHost!,
  });

  if (!initialized) {
    return <>{children}</>;
  }

  return (
    <PostHogProvider client={posthog}>
      <PostHogErrorBoundary>{children}</PostHogErrorBoundary>
    </PostHogProvider>
  );
}
